/* ADD Knowledge categories */
export const ADD_CUSTOMER = "ADD_CUSTOMER"
export const ADD_CUSTOMER_SUCCESS = "ADD_CUSTOMER_SUCCESS"
export const ADD_CUSTOMER_CLEAN = "ADD_CUSTOMER_CLEAN"
export const ADD_CUSTOMER_ERROR = "ADD_CUSTOMER_ERROR"
